export default {
  'database.title': '数据库',
  'database.create': '新建数据库',
  'database.mySql': 'MySQL',
  'database.redis': 'Redis',
  'database.milvus': 'Milvus',
  'database.sqlite': 'SQLite',
  'database.more': '更多数据库管理敬请期待...',
  'database.create.mysql': '创建 MySQL 数据库',
  'database.create.redis': '创建 Redis 实例',
  'database.columns.instances': '实例',
  'database.columns.status': '状态',
  'database.columns.type': '类型',
  'database.columns.plan': '规格',
  'database.columns.region': '区域',
  'database.columns.creationTime': '创建时间',
  'database.columns.actions': '操作',
  'database.columns.keyName': '键',
  'database.status.running': '运行中',
  'database.type.singleNode': '单节点',
  'database.plan.basic': '基础版',
  'database.region.asiaSingapore': '亚太-新加坡',
  'database.action.edit': '编辑',
  'database.action.delete': '删除',
  'database.action.delete.confirm': '确认删除该数据库吗？',
  'database.action.delete.key.confirm': '确定删除该键吗？',
  'database.create.success': '创建数据库 {name} 成功',
  'database.create.fail': '创建数据库 {name} 失败: {message}',
  'database.delete.success': '删除数据库 {name} 成功',
  'database.delete.fail': '删除数据库 {name} 失败: {error}',
  'database.metrics': '监控',
  'database.metrics.timeRange': '时间范围',
  'database.metrics.precision': '精度',
  'database.metrics.range1h': '最近 1 小时',
  'database.metrics.range6h': '最近 6 小时',
  'database.metrics.range1d': '最近 1 天',
  'database.metrics.range7d': '最近 7 天',
  'database.metrics.range30d': '最近 30 天',
  'database.metrics.precision1m': '1 分钟',
  'database.metrics.precision5m': '5 分钟',
  'database.metrics.precision15m': '15 分钟',
  'database.metrics.precision1h': '1 小时',
  'database.metrics.cpu': 'CPU 利用率',
  'database.metrics.memory': '内存利用率',
  'database.metrics.storage': '持久化存储使用量',
  'database.metrics.noData': '暂无监控数据',
  'database.metrics.fetchFailed': '获取监控指标失败',
  // Redis 实例管理
  'database.redis.createInstance': '创建实例',
  'database.redis.instanceId': '实例ID',
  'database.redis.instanceName': '实例名称',
  'database.redis.name': '别名',
  'database.redis.status': '状态',
  'database.redis.type': '部署模式',
  'database.redis.plan': '规格',
  'database.redis.region': '区域',
  'database.redis.creationTime': '创建时间',
  'database.redis.operation': '操作',

  'database.redis.delete': '删除',
  'database.redis.deleteConfirm': '确认删除',
  'database.redis.deleteConfirmContent': '确定要删除实例 {name} 吗？',
  'database.redis.deleteSuccess': '删除成功',
  'database.redis.deleteFail': '删除失败',
  'database.redis.fetchListFail': '获取实例列表失败',
  // 创建实例模态框
  'database.redis.createModal.title': '创建Redis数据库实例',
  'database.redis.createModal.name': '别名',
  'database.redis.createModal.namePlaceholder': '请输入别名',
  'database.redis.createModal.nameRequired': '请输入别名',
  'database.redis.createModal.instanceName': '实例名称',
  'database.redis.createModal.instanceNamePlaceholder': '请输入实例名称',
  'database.redis.createModal.instanceNameRequired': '请输入实例名称',
  'database.redis.createModal.instanceNameInvalid':
    '实例名称必须以字母开头，只能包含字母、数字和下划线',
  'database.redis.createModal.region': '区域',
  'database.redis.createModal.regionRequired': '请选择区域',
  'database.redis.createModal.type': '类型',
  'database.redis.createModal.typeRequired': '请选择类型',
  'database.redis.createModal.typeSingleNode': 'Single Node',
  'database.redis.createModal.typeHighAvailability': 'High Availability',
  'database.redis.createModal.plan': '规格',
  'database.redis.createModal.planRequired': '请选择规格',
  'database.redis.createModal.availabilityMode': '部署模式',
  'database.redis.createModal.availabilityModeRequired': '请选择部署模式',
  'database.redis.createModal.modeSingle': 'Single Node',
  'database.redis.createModal.modeMulti': 'High Availability',
  'database.redis.createModal.modeSingleDesc':
    'Suitable for individual developers and small-to-medium teams. Designed for development and testing workloads.',
  'database.redis.createModal.modeMultiDesc':
    'Designed for production workloads requiring high reliability and availability. Built-in redundancy and failover. Supports storage scaling.',
  'database.redis.createModal.flavor': '规格',
  'database.redis.createModal.flavorRequired': '请选择规格',
  'database.redis.createModal.version': 'Redis版本',
  'database.redis.createModal.createSuccess': '创建请求已发送',
  'database.redis.createModal.createFail': '创建失败',
  'database.redis.createModal.fetchRegionsFail': '获取可用地域失败',
  'database.redis.createModal.fetchFlavorsFail': '获取可用规格失败',
  'database.redis.createModal.creditsPerHour': '积分/小时',
  'database.redis.createModal.computeCredits': '计算资源',
  'database.redis.createModal.storageCredits': '存储资源',
  'database.redis.createModal.totalCredits': '总计每小时消耗: {credits} 积分',
  'database.redis.createModal.connectionConfigName': '连接配置名称',
  'database.redis.createModal.connectionConfigNamePlaceholder':
    '留空将自动生成 Redis-{host}-{User}',
  'database.redis.createModal.connectionConfigNameTip':
    '用于在配置中心标识该 Redis 实例的连接配置，与实例绑定，创建后不可删除。',
  'database.redis.createModal.instanceNameAutoHint': '留空将自动生成',
  // 实例列表增强
  'database.redis.filterByStatus': '按状态筛选',
  'database.redis.statusRunning': '运行中',
  'database.redis.statusCreating': '创建中',
  'database.redis.statusDeleting': '删除中',
  'database.redis.statusDeleted': '已删除',
  'database.redis.statusUpgrading': '升级中',
  'database.redis.showDeleted': '显示已删除',
  'database.redis.hideDeleted': '隐藏已删除',
  'database.redis.deleted': '已删除',
  'database.redis.manage': '管理',
  // 实例详情
  'database.redis.fetchInstanceFail': '获取实例详情失败',
  'database.redis.keys': '键管理',
  'database.redis.createKey': '创建键',
  'database.redis.searchKeyPlaceholder': '按键模式筛选（例如 user:*）',
  'database.redis.fetchKeysFail': '获取键列表失败',
  // Redis 键模态框
  'database.redis.keyModal.editTitle': '编辑 Redis 键',
  'database.redis.keyModal.createTitle': '创建 Redis 键',
  'database.redis.keyModal.saving': '保存中...',
  'database.redis.keyModal.save': '保存',
  'database.redis.keyModal.loading': '加载中...',
  'database.redis.keyModal.keyName': 'Redis 键名',
  'database.redis.keyModal.keyNamePlaceholder': '请输入',
  'database.redis.keyModal.keyNameRequired': '请输入 Redis 键名',
  'database.redis.keyModal.keyType': 'Redis 键类型',
  'database.redis.keyModal.keyTypePlaceholder': '请选择',
  'database.redis.keyModal.keyTypeRequired': '请选择 Redis 键类型',
  'database.redis.keyModal.keyValue': 'Redis 键值',
  'database.redis.keyModal.stringPlaceholder': '请输入字符串值',
  'database.redis.keyModal.startIndex': '开始索引',
  'database.redis.keyModal.endIndex': '结束索引',
  'database.redis.keyModal.search': '查询',
  'database.redis.keyModal.noData': '暂无数据',
  'database.redis.keyModal.listLength': '列表长度：{length}',
  'database.redis.keyModal.listIndex': '索引',
  'database.redis.keyModal.listValue': '值',
  'database.redis.keyModal.listValuePlaceholder': '请输入值',
  'database.redis.keyModal.lpush': '左插入',
  'database.redis.keyModal.rpush': '右插入',
  'database.redis.keyModal.lpop': '左弹出',
  'database.redis.keyModal.rpop': '右弹出',
  'database.redis.keyModal.pushValuePlaceholder': '请输入要插入的值',
  'database.redis.keyModal.listElementRequired':
    'List 键必须包含至少一个元素。',
  'database.redis.keyModal.confirmPopElement':
    '此操作将永久移除列表中的一个元素，是否继续？',
  'database.redis.keyModal.copyValue': '复制值',
  'database.redis.keyModal.fieldName': '字段名',
  'database.redis.keyModal.fieldValue': '字段值',
  'database.redis.keyModal.fieldNamePlaceholder': '字段名 (Field)',
  'database.redis.keyModal.fieldValuePlaceholder': '字段值 (Value)',
  'database.redis.keyModal.copyFieldValue': '复制字段值',
  'database.redis.keyModal.add': '添加',
  'database.redis.keyModal.expiration': 'Redis 键过期时间 (秒)',
  'database.redis.keyModal.expirationPlaceholder': '0 表示永久',
  'database.redis.keyModal.seconds': '秒',
  'database.redis.keyModal.fieldAndValueRequired': '字段名和值不能为空',
  'database.redis.keyModal.saveHashFieldFailed': '保存哈希字段失败',
  'database.redis.keyModal.copySuccess': '复制成功',
  'database.redis.keyModal.copyFailed': '复制失败',
  'database.redis.keyModal.loadKeyFailed': '加载键信息失败:{error}',
  'database.redis.keyModal.expiresAt': '预计于 {time} 过期',
  'database.redis.keyModal.permanent': '永久 (不会过期)',
  'database.redis.keyModal.saveKeyFailed': '保存键值失败',
  'database.redis.keyModal.stringEmptyAllowed': '允许空字符串作为值。',
  'database.redis.keyModal.hashFieldRequired': 'Hash 键必须包含至少一个字段。',
  'database.redis.keyModal.fieldNameDuplicate':
    '字段名已存在，请使用不同的字段名',
  // Redis Hook 消息
  'database.redis.hook.setKeySuccess': '设置键值成功',
  'database.redis.hook.setKeyFail': '设置键值失败',
  'database.redis.hook.getKeyFail': '获取键值失败',
  'database.redis.hook.deleteKeysSuccess': '成功删除{count}个键',
  'database.redis.hook.deleteKeysFail': '删除键失败',
  'database.redis.hook.getTTLFail': '获取剩余生存时间失败',
  'database.redis.hook.getKeyTypeFail': '获取键类型失败',
  'database.redis.hook.setHashFieldSuccess': '设置哈希字段成功',
  'database.redis.hook.setHashFieldFail': '设置哈希字段失败',
  'database.redis.hook.getHashFieldsFail': '获取所有哈希字段失败',
  'database.redis.hook.deleteHashFieldsSuccess': '删除哈希字段成功',
  'database.redis.hook.deleteHashFieldsFail': '删除哈希字段失败',
  'database.redis.hook.getListLengthFail': '获取列表长度失败',
  'database.redis.hook.getListRangeFail': '获取列表范围失败',
  'database.redis.hook.expireKeyFail': '设置过期时间失败',
  'database.redis.hook.getListIndexFail': '获取列表元素失败',
  'database.redis.hook.listLPopSuccess': '左弹出成功',
  'database.redis.hook.listLPopFail': '左弹出失败',
  'database.redis.hook.listLPushSuccess': '左插入成功',
  'database.redis.hook.listLPushFail': '左插入失败',
  'database.redis.hook.listRPopSuccess': '右弹出成功',
  'database.redis.hook.listRPopFail': '右弹出失败',
  'database.redis.hook.listRPushSuccess': '右插入成功',
  'database.redis.hook.listRPushFail': '右插入失败',
  'database.redis.hook.listSetSuccess': '更新列表元素成功',
  'database.redis.hook.listSetFail': '更新列表元素失败',
  'database.redis.hook.listTrimSuccess': '裁剪列表成功',
  'database.redis.hook.listTrimFail': '裁剪列表失败',
  // MySQL 实例管理
  'database.mysql.createInstance': '创建实例',
  'database.mysql.instanceId': '实例ID',
  'database.mysql.instanceName': '实例名称',
  'database.mysql.name': '别名',
  'database.mysql.status': '状态',
  'database.mysql.type': '部署模式',
  'database.mysql.plan': '规格',
  'database.mysql.region': '区域',
  'database.mysql.creationTime': '创建时间',
  'database.mysql.operation': '操作',
  'database.mysql.delete': '删除',
  'database.mysql.deleteConfirm': '确认删除',
  'database.mysql.deleteConfirmContent': '确定要删除实例 {name} 吗？',
  'database.mysql.deleteSuccess': '删除成功',
  'database.mysql.deleteFail': '删除失败',
  'database.mysql.fetchListFail': '获取实例列表失败',
  // 创建实例模态框
  'database.mysql.createModal.title': '创建MySQL数据库实例',
  'database.mysql.createModal.name': '别名',
  'database.mysql.createModal.namePlaceholder': '请输入别名',
  'database.mysql.createModal.nameRequired': '请输入别名',
  'database.mysql.createModal.instanceName': '实例名称',
  'database.mysql.createModal.instanceNamePlaceholder': '请输入实例名称',
  'database.mysql.createModal.instanceNameAutoGen':
    '留空则自动生成（如 mysql_instance_ab12）',
  'database.mysql.createModal.instanceNameRequired': '请输入实例名称',
  'database.mysql.createModal.instanceNameInvalid':
    '实例名称必须以字母开头，只能包含字母、数字和下划线',
  'database.mysql.createModal.region': '区域',
  'database.mysql.createModal.regionRequired': '请选择区域',
  'database.mysql.createModal.type': '类型',
  'database.mysql.createModal.typeRequired': '请选择类型',
  'database.mysql.createModal.typeSingleNode': 'Single Node',
  'database.mysql.createModal.typeHighAvailability': 'High Availability',
  'database.mysql.createModal.plan': '规格',
  'database.mysql.createModal.planRequired': '请选择规格',
  'database.mysql.createModal.availabilityMode': '部署模式',
  'database.mysql.createModal.availabilityModeRequired': '请选择部署模式',
  'database.mysql.createModal.modeSingle': 'Single Node',
  'database.mysql.createModal.modeMulti': 'High Availability',
  'database.mysql.createModal.modeSingleDesc':
    'Suitable for individual developers and small-to-medium teams. Designed for development and testing workloads.',
  'database.mysql.createModal.modeMultiDesc':
    'Designed for production workloads requiring high reliability and availability. Built-in redundancy and failover. Supports storage scaling.',
  'database.mysql.createModal.flavor': '规格',
  'database.mysql.createModal.flavorRequired': '请选择规格',
  'database.mysql.createModal.storage': '存储空间',
  'database.mysql.createModal.storageUnit': 'GB',
  'database.mysql.createModal.version': 'MySQL版本',
  'database.mysql.createModal.planBasic': 'Basic (1 Core, 2 GB RAM)',
  'database.mysql.createModal.planBasicHA': 'Basic (2 Cores, 4 GB RAM)',
  'database.mysql.createModal.planStarter': 'Starter (2 Cores, 2 GB RAM)',
  'database.mysql.createModal.planLaunch': 'Launch (2 Cores, 4 GB RAM)',
  'database.mysql.createModal.planScale': 'Scale (4 Cores, 8 GB RAM)',
  'database.mysql.createModal.planPerformance':
    'Performance (8 Cores, 16 GB RAM)',
  'database.mysql.createModal.quotaExceeded':
    '已超出免费计划资源额度，请升级您的计划',
  'database.mysql.createModal.pointsInsufficient':
    '您的积分不足，请充值或升级您的计划',
  'database.mysql.createModal.createSuccess': '创建请求已发送',
  'database.mysql.createModal.createFail': '创建失败',
  'database.mysql.createModal.fetchRegionsFail': '获取可用地域失败',
  'database.mysql.createModal.fetchStorageRangeFail': '获取存储范围失败',
  'database.mysql.createModal.fetchFlavorsFail': '获取可用规格失败',
  'database.mysql.createModal.creditsPerHour': '积分/小时',
  'database.mysql.createModal.computeCredits': '计算资源',
  'database.mysql.createModal.storageCredits': '存储资源',
  'database.mysql.createModal.storageNoExpand': '不支持扩容',
  'database.mysql.createModal.totalCredits': '总计每小时消耗: {credits} 积分',
  // 实例列表增强
  'database.mysql.filterByStatus': '按状态筛选',
  'database.mysql.statusRunning': '运行中',
  'database.mysql.statusCreating': '创建中',
  'database.mysql.statusDeleting': '删除中',
  'database.mysql.statusDeleted': '已删除',
  'database.mysql.statusUpgrading': '升级中',
  'database.mysql.showDeleted': '显示已删除',
  'database.mysql.hideDeleted': '隐藏已删除',
  'database.mysql.deleted': '已删除',
  'database.mysql.manage': '管理',
  'database.mysql.deleteDatabase': '删除',
  'database.mysql.deleteDatabaseConfirm': '删除数据库',
  'database.mysql.deleteDatabaseConfirmContent':
    '确定要删除数据库 "{name}" 吗？此操作不可撤销。',
  'database.mysql.deleteDatabaseSuccess': '数据库删除成功',
  'database.mysql.deleteDatabaseFail': '数据库删除失败',
  // 实例详情
  'database.mysql.viewUsage': '查看用量',
  'database.mysql.usageComingSoon': '监控功能即将推出',
  'database.mysql.fetchInstanceFail': '获取实例详情失败',
  'database.mysql.databases': '数据库',
  'database.mysql.createDatabase': '创建数据库',
  'database.mysql.fetchDatabasesFail': '获取数据库列表失败',
  // 数据库管理
  'database.mysql.databaseName': '数据库名称',
  'database.mysql.databaseNamePlaceholder':
    '请输入数据库名称（以小写字母开头，只能包含小写字母、数字和下划线）',
  'database.mysql.databaseNameRequired': '请输入数据库名称',
  'database.mysql.databaseNameMustStartWithLetter':
    '数据库名称必须以小写字母开头',
  'database.mysql.databaseNameInvalidChars':
    '数据库名称只能包含小写字母、数字和下划线',
  'database.mysql.databaseNameTooLong': '数据库名称不能超过64个字符',
  'database.mysql.description': '描述',
  'database.mysql.descriptionPlaceholder': '请输入数据库描述（可选）',
  'database.mysql.connectionConfigName': '连接配置名称',
  'database.mysql.connectionConfigNamePlaceholder': '留空将自动生成',
  'database.mysql.connectionConfigNameTip':
    '用于标识该数据库的连接配置，将出现在配置中心',
  'database.mysql.createDatabaseSuccess': '创建数据库成功',
  'database.mysql.createDatabaseFail': '创建数据库失败',
  // 表管理
  'database.mysql.createTable': '创建数据表',
  'database.mysql.editTable': '编辑表',
  'database.mysql.copyTable': '复制表',
  'database.mysql.copyTableSchema': '复制表模式',
  'database.mysql.copyTableSchemaSuccess': 'Schema 已复制到剪贴板',
  'database.mysql.copyTableSchemaFail': '复制失败',
  'database.mysql.exportTableData': '导出表数据',
  'database.mysql.exportTableDataSuccess': '导出成功',
  'database.mysql.exportTableDataFail': '导出失败',
  'database.mysql.deleteTable': '删除表',
  'database.mysql.deleteTableConfirm':
    '确定要删除数据表 {name} 吗？删除后不可恢复。',
  'database.mysql.deleteTableSuccess': '删除表成功',
  'database.mysql.deleteTableFail': '删除表失败',
  'database.mysql.structure': '结构',
  'database.mysql.content': '数据',
  'database.mysql.query': '查询',
  'database.mysql.selectTableHint': '请从左侧选择一张表',
  'database.mysql.targetTableName': '目标表名',
  'database.mysql.targetTableNamePlaceholder': '请输入目标表名',
  'database.mysql.targetTableNameRequired': '请输入目标表名',
  'database.mysql.copyData': '复制数据',
  'database.mysql.copyDataTip': '勾选后将同时复制表数据，否则仅复制表结构',
  'database.mysql.copyTableSuccess': '复制表成功',
  'database.mysql.copyTableFail': '复制表失败',
  'database.mysql.editTableTip': '请使用 DDL SQL 语句编辑表结构',
  'database.mysql.ddlSqlPlaceholder': '请输入 DDL SQL 语句',
  'database.mysql.ddlSqlRequired': '请输入 DDL SQL 语句',
  'database.mysql.fetchTableSchemaFail': '获取表结构失败',
  'database.mysql.editTableSuccess': '编辑表成功',
  'database.mysql.editTableFail': '编辑表失败',
  // 表结构管理
  'database.mysql.addField': '新增字段',
  'database.mysql.fieldName': '字段名称',
  'database.mysql.fieldDescription': '描述',
  'database.mysql.dataType': '数据类型',
  'database.mysql.length': '长度',
  'database.mysql.defaultValue': '默认值',
  'database.mysql.required': '非空字段',
  'database.mysql.unique': '是否唯一',
  'database.mysql.autoIncrement': '是否自增',
  'database.mysql.autoIncrementRequiresInt':
    '自增仅支持整数类型（INT / BIGINT）',
  'database.mysql.autoIncrementRequiresKey': '自增要求字段为主键或唯一键',
  'database.mysql.primaryKey': '主键',
  'database.mysql.deleteFieldConfirm': '确定删除该字段吗?',
  'database.mysql.fieldNameEmpty': '字段名不能为空！',
  'database.mysql.fieldNameDuplicate': '字段名不能重复！',
  // 表数据管理
  'database.mysql.selectField': '选择字段',
  'database.mysql.operator': '运算符',
  'database.mysql.inputValue': '输入值',
  'database.mysql.search': '查询',
  'database.mysql.reset': '重置',
  'database.mysql.addRow': '新增行',
  'database.mysql.clear': '清空数据',
  'database.mysql.showFields': '展示字段',
  'database.mysql.selectFieldsToShow': '选择要显示的字段',
  'database.mysql.defaultValueTip': '该字段默认值：{value}',
  'database.mysql.deleteRowConfirm': '确定删除该行吗?',
  'database.mysql.clearTableData': '清空表数据',
  'database.mysql.clearTableDataConfirm': '确认清空数据？',
  'database.mysql.clearTableDataWarning': '数据清空后不可恢复，请谨慎操作。',
  'database.mysql.operatorEqual': '等于',
  'database.mysql.operatorNotEqual': '不等于',
  'database.mysql.operatorGreater': '大于',
  'database.mysql.operatorGreaterEqual': '大于等于',
  'database.mysql.operatorLess': '小于',
  'database.mysql.operatorLessEqual': '小于等于',
  'database.mysql.operatorLike': '包含',
  'database.mysql.operatorStarts': '开头是',
  'database.mysql.operatorEnds': '结尾是',
  'database.mysql.operatorIsNull': '为空',
  'database.mysql.operatorIsNotNull': '不为空',
  // SQL 执行
  'database.mysql.sqlPlaceholder': '请输入SQL语句',
  'database.mysql.clearSQL': '清空',
  'database.mysql.executeSQL': '执行',
  'database.mysql.sqlEmptyState': '请在上方输入SQL语句并点击执行',
  'database.mysql.sqlInputRequired': '请输入SQL语句',
  'database.mysql.sqlExecuteSuccess': '执行成功，影响 {rows} 行',
  'database.mysql.sqlExecuteFail': '执行失败：{error}',
  // useMysql hook 消息
  'database.mysql.getDatabaseInfoFail':
    '获取数据库 {database} 信息失败：{error}',
  'database.mysql.addTableSuccess': '添加表 {name} 成功！',
  'database.mysql.addTableFail': '添加表 {name} 失败：{error}',
  'database.mysql.getTableColumnsFail': '获取表 {table} 字段信息失败：{error}',
  'database.mysql.getTableDataFail': '获取表 {table} 数据信息失败：{error}',
  'database.mysql.updateTableColumnSuccess': '更新表 {table} 字段信息成功！',
  'database.mysql.updateTableColumnFail':
    '更新表 {table} 字段信息失败：{error}',
  'database.mysql.addColumnSuccess': '添加字段 {name} 成功！',
  'database.mysql.addColumnFail': '添加字段 {name} 失败：{error}',
  'database.mysql.deleteColumnSuccess': '删除字段 {name} 成功！',
  'database.mysql.deleteColumnFail': '删除字段 {name} 失败：{error}',
  'database.mysql.addRowSuccess': '添加数据成功！',
  'database.mysql.addRowFail': '添加数据失败：{error}',
  'database.mysql.fieldDefaultValue': '默认值：{value}',
  'database.mysql.updateRowSuccess': '更新数据成功！',
  'database.mysql.updateRowFail': '更新数据失败：{error}',
  'database.mysql.deleteRowSuccess': '删除数据成功！',
  'database.mysql.deleteRowFail': '删除数据失败：{error}',
  'database.mysql.clearTableDataSuccess': '清空表 {table} 数据成功！',
  'database.mysql.clearTableDataFail': '清空表 {table} 数据失败：{error}',
  'database.mysql.executeSQLSuccess': 'SQL执行成功！',
  'database.mysql.executeSQLFail': 'SQL执行失败：{error}',
  // 创建表
  'database.mysql.createTableModal.title': '新建数据表',
  'database.mysql.createTableModal.tableName': '数据表名称',
  'database.mysql.createTableModal.tableNamePlaceholder': '请输入数据表名称',
  'database.mysql.createTableModal.tableNameRequired': '请输入数据表名称',
  'database.mysql.createTableModal.tableNameMaxLength':
    '数据表名最大长度为64个字符',
  'database.mysql.createTableModal.columns': '数据表字段',
  'database.mysql.createTableModal.addField': '添加字段',
  'database.mysql.createTableModal.fieldName': '字段名称',
  'database.mysql.createTableModal.fieldNamePlaceholder': '请输入字段名称',
  'database.mysql.createTableModal.description': '描述',
  'database.mysql.createTableModal.descriptionPlaceholder': '请输入字段描述',
  'database.mysql.createTableModal.dataType': '数据类型',
  'database.mysql.createTableModal.size': '大小',
  'database.mysql.createTableModal.defaultValue': '默认值',
  'database.mysql.createTableModal.required': '是否必要',
  'database.mysql.createTableModal.unique': '是否唯一',
  'database.mysql.createTableModal.autoIncrement': '自增',
  'database.mysql.createTableModal.primaryKey': '主键',
  'database.mysql.createTableModal.delete': '删除',
  'database.mysql.createTableModal.columnsRequired': '请添加字段',
  'database.mysql.createTableModal.fieldNameEmpty': '字段名不能为空！',
  'database.mysql.createTableModal.fieldNameDuplicate': '字段名不能重复！',
  'database.mysql.createTableModal.primaryKeyRequired': '请指定主键！',
  // Milvus 实例管理
  'database.milvus.createInstance': '创建实例',
  'database.milvus.instanceId': '实例 ID',
  'database.milvus.instanceName': '实例名称',
  'database.milvus.name': '别名',
  'database.milvus.status': '状态',
  'database.milvus.mode': '部署模式',
  'database.milvus.plan': '规格',
  'database.milvus.region': '区域',
  'database.milvus.creationTime': '创建时间',
  'database.milvus.operation': '操作',
  'database.milvus.delete': '删除',
  'database.milvus.manage': '管理',
  'database.milvus.deleted': '已删除',
  'database.milvus.deleteConfirm': '确认删除',
  'database.milvus.deleteConfirmTitle': '删除 Milvus 实例',
  'database.milvus.deleteConfirmContent':
    '确定要删除实例 {name} 吗？实例内所有集合和数据将被释放且不可恢复。',
  'database.milvus.deleteSuccess': '删除成功',
  'database.milvus.deleteFail': '删除失败',
  'database.milvus.fetchListFail': '获取实例列表失败',
  'database.milvus.fetchInstanceFail': '获取实例详情失败',
  'database.milvus.statusRunning': '运行中',
  'database.milvus.statusCreating': '创建中',
  'database.milvus.statusDeleting': '删除中',
  'database.milvus.statusDeleted': '已删除',
  'database.milvus.statusUpgrading': '升级中',
  'database.milvus.statusSuspended': '已暂停',
  'database.milvus.filterByStatus': '按状态筛选',
  'database.milvus.notOwnerTip': '仅工作空间所有者可创建 Milvus 实例',
  // 创建实例弹窗
  'database.milvus.createModal.title': '创建 Milvus 数据库实例',
  'database.milvus.createModal.name': '别名',
  'database.milvus.createModal.namePlaceholder': '请输入别名（如：开发数据库）',
  'database.milvus.createModal.nameRequired': '请输入别名',
  'database.milvus.createModal.instanceName': '实例名称',
  'database.milvus.createModal.instanceNamePlaceholder': '留空则自动生成',
  'database.milvus.createModal.instanceNameInvalid':
    '实例名称必须以字母开头，只能包含字母、数字和下划线，长度 2-255 个字符',
  'database.milvus.createModal.instanceNameAutoHint': '留空将自动生成',
  'database.milvus.createModal.region': '部署地域',
  'database.milvus.createModal.regionRequired': '请选择地域',
  'database.milvus.createModal.availabilityMode': '部署模式',
  'database.milvus.createModal.availabilityModeRequired': '请选择部署模式',
  'database.milvus.createModal.modeSingle': 'Single Node',
  'database.milvus.createModal.modeMulti': 'High Availability',
  'database.milvus.createModal.singleNodeDesc':
    '所有组件以单副本运行，资源占用最小。不建议用于有 SLA 保证要求的生产环境。',
  'database.milvus.createModal.haDesc':
    '一主两备高可用架构，适合生产环境，可手动扩容存储。',
  'database.milvus.createModal.plan': '规格（Plan）',
  'database.milvus.createModal.planRequired': '请选择规格',
  'database.milvus.createModal.flavor': '规格（Plan）',
  'database.milvus.createModal.flavorRequired': '请选择规格',
  'database.milvus.createModal.connectionConfigName': '连接配置名称',
  'database.milvus.createModal.connectionConfigNamePlaceholder':
    '留空将自动生成 Milvus-{host}-{User}',
  'database.milvus.createModal.connectionConfigNameTip':
    '用于在配置中心标识该 Milvus 实例的连接配置，与实例绑定，创建后不可删除。',
  'database.milvus.createModal.creditsPerHour': ' 积分/小时',
  'database.milvus.createModal.createSuccess': '创建请求已发送',
  'database.milvus.createModal.createFail': '创建失败',
  'database.milvus.createModal.fetchFlavorsFail': '获取可用规格失败',
  'database.milvus.createModal.fetchRegionsFail': '获取可用地域失败',
  'database.milvus.createModal.quotaExceeded': '已超出资源额度，请升级您的计划',
  'database.milvus.createModal.pointsInsufficient':
    '积分不足，请充值或升级您的计划',
  // 实例详情
  'database.milvus.overview': '概况',
  'database.milvus.collections': '集合',
  'database.milvus.overviewInstanceId': '实例 ID',
  'database.milvus.overviewInstanceName': '实例名称',
  'database.milvus.overviewRegion': '地域',
  'database.milvus.overviewMode': '部署模式',
  'database.milvus.overviewPlan': '规格',
  'database.milvus.overviewStatus': '状态',
  // 集合列表
  'database.milvus.collectionName': '集合名称',
  'database.milvus.collectionAliases': '别名',
  'database.milvus.collectionRowCount': '数据量',
  'database.milvus.collectionLoadProgress': '加载进度',
  'database.milvus.collectionOperation': '操作',
  'database.milvus.createCollection': '创建集合',
  'database.milvus.fetchCollectionsFail': '获取集合列表失败',
  'database.milvus.deleteCollection': '删除集合',
  'database.milvus.deleteCollectionConfirm':
    'Once you drop the collection, all the data in this collection will be cleaned as well. This action cannot be undone.',
  'database.milvus.deleteCollectionSuccess': '删除集合成功',
  'database.milvus.deleteCollectionFail': '删除集合失败',
  // 创建集合弹窗
  'database.milvus.createCollectionModal.title': '创建集合',
  'database.milvus.createCollectionModal.collectionName': '集合名称',
  'database.milvus.createCollectionModal.collectionNamePlaceholder':
    '请输入集合名称',
  'database.milvus.createCollectionModal.collectionNameRequired':
    '请输入集合名称',
  'database.milvus.createCollectionModal.collectionNameInvalid':
    '集合名称必须以小写字母开头，只能包含小写字母、数字和下划线，最长 64 个字符',
  'database.milvus.createCollectionModal.description': '描述',
  'database.milvus.createCollectionModal.descriptionPlaceholder':
    '请输入集合描述（可选）',
  'database.milvus.createCollectionModal.ttl': 'TTL',
  'database.milvus.createCollectionModal.ttlPlaceholder': 'TTL (秒)',
  'database.milvus.createCollectionModal.dynamicField': 'Dynamic Field',
  'database.milvus.createCollectionModal.dynamicFieldTip':
    '启用 Dynamic Field 允许在插入数据时添加新字段而无需修改 Schema，适合结构灵活或不断演变的数据。可能增加存储开销并影响查询性能。',
  'database.milvus.createCollectionModal.schema': 'Schema',
  'database.milvus.createCollectionModal.addField': '添加字段',
  'database.milvus.createCollectionModal.fieldName': '字段名称',
  'database.milvus.createCollectionModal.fieldType': '字段类型',
  'database.milvus.createCollectionModal.fieldDescription': '描述',
  'database.milvus.createCollectionModal.moreSetting': '更多设置',
  'database.milvus.createCollectionModal.action': '操作',
  'database.milvus.createCollectionModal.delete': '删除',
  'database.milvus.createCollectionModal.dimension': '维度',
  'database.milvus.createCollectionModal.maxLength': '最大长度',
  'database.milvus.createCollectionModal.maxCapacity': '最大容量',
  'database.milvus.createCollectionModal.metricType': 'Metric Type',
  'database.milvus.createCollectionModal.indexType': 'Index Type',
  'database.milvus.createCollectionModal.nullable': 'Nullable',
  'database.milvus.createCollectionModal.defaultValue': '默认值',
  'database.milvus.createCollectionModal.enableIndex': '建立索引',
  'database.milvus.createCollectionModal.autoId': 'Auto ID',
  'database.milvus.createCollectionModal.autoIdTip':
    '启用后系统自动生成主键，无需在插入数据时提供该字段。',
  'database.milvus.createCollectionModal.primaryKeyRequired':
    '必须指定主键字段',
  'database.milvus.createCollectionModal.vectorFieldRequired':
    '至少需要一个向量类型字段',
  'database.milvus.createCollectionModal.fieldNameRequired': '字段名称不能为空',
  'database.milvus.createCollectionModal.fieldNameDuplicate':
    '字段名称不能重复',
  'database.milvus.createCollectionModal.createSuccess': '创建集合成功',
  'database.milvus.createCollectionModal.createFail': '创建集合失败',
  'database.milvus.createCollectionModal.editStructFields':
    '编辑 ARRAY<STRUCT> 字段',
  // 集合管理页
  'database.milvus.collection.rename': '重命名',
  'database.milvus.collection.alias': '别名管理',
  'database.milvus.collection.addField': '添加字段',
  'database.milvus.collection.dataImport': '导入数据',
  'database.milvus.collection.vectorSearch': '向量检索',
  'database.milvus.collection.rowCount': '数据量',
  'database.milvus.collection.loadProgress': '加载进度',
  'database.milvus.collection.renameModal.title': '重命名集合',
  'database.milvus.collection.renameModal.newName': '新名称',
  'database.milvus.collection.renameModal.newNameRequired': '请输入新名称',
  'database.milvus.collection.renameModal.success': '重命名成功',
  'database.milvus.collection.renameModal.fail': '重命名失败',
  'database.milvus.collection.aliasModal.title': '别名管理',
  'database.milvus.collection.aliasModal.setAlias': '设置别名',
  'database.milvus.collection.aliasModal.removeAlias': '移除别名',
  'database.milvus.collection.aliasModal.alias': '别名',
  'database.milvus.collection.aliasModal.aliasRequired': '请输入别名',
  'database.milvus.collection.aliasModal.setSuccess': '设置别名成功',
  'database.milvus.collection.aliasModal.setFail': '设置别名失败',
  'database.milvus.collection.aliasModal.removeSuccess': '移除别名成功',
  'database.milvus.collection.aliasModal.removeFail': '移除别名失败',
  'database.milvus.collection.addFieldModal.title': '添加字段',
  'database.milvus.collection.addFieldModal.tip':
    '仅在 Dynamic Field 已启用的集合中可用',
  'database.milvus.collection.addFieldModal.success': '添加字段成功',
  'database.milvus.collection.addFieldModal.fail': '添加字段失败',
  'database.milvus.collection.importModal.title': '导入数据',
  'database.milvus.collection.importModal.format': '文件格式',
  'database.milvus.collection.importModal.file': '选择文件',
  'database.milvus.collection.importModal.fileTip':
    '支持 JSON/CSV，单次最大 10MB',
  'database.milvus.collection.importModal.fileRequired': '请选择文件',
  'database.milvus.collection.importModal.partition': '分区名称（可选）',
  'database.milvus.collection.importModal.success':
    '导入成功，共导入 {count} 条',
  'database.milvus.collection.importModal.fail': '导入失败',
  'database.milvus.collection.search.title': '向量检索 Playground',
  'database.milvus.collection.search.modeRaw': '原始向量',
  'database.milvus.collection.search.modeEmbedding': 'Embedding 文本',
  'database.milvus.collection.search.vectorField': '向量字段',
  'database.milvus.collection.search.queryVector': '查询向量（JSON 数组）',
  'database.milvus.collection.search.queryText': '查询文本',
  'database.milvus.collection.search.embeddingConfig': 'Embedding 配置',
  'database.milvus.collection.search.topK': 'Top K',
  'database.milvus.collection.search.outputFields': '输出字段',
  'database.milvus.collection.search.filterExpr': '过滤表达式（可选）',
  'database.milvus.collection.search.metricType': 'Metric Type',
  'database.milvus.collection.search.execute': '执行检索',
  'database.milvus.collection.search.results': '检索结果',
  'database.milvus.collection.search.noResults': '暂无结果',
  'database.milvus.collection.search.fail': '检索失败',
  'database.milvus.collection.fetchStatsFail': '获取集合统计信息失败',
  'database.milvus.collection.fetchDescribeFail': '获取集合详情失败',
  // Postgres 实例管理
  'database.postgres': 'PostgreSQL',
  'database.postgres.createInstance': '创建实例',
  'database.postgres.instanceId': '实例 ID',
  'database.postgres.instanceName': '实例名称',
  'database.postgres.name': '别名',
  'database.postgres.status': '状态',
  'database.postgres.mode': '部署模式',
  'database.postgres.plan': '规格',
  'database.postgres.region': '区域',
  'database.postgres.creationTime': '创建时间',
  'database.postgres.operation': '操作',

  'database.postgres.delete': '删除',
  'database.postgres.deleteConfirm': '确认删除',
  'database.postgres.deleteConfirmTitle': '删除实例',
  'database.postgres.deleteConfirmContent':
    '确定要删除实例 {name} 吗？删除后该实例中所有数据库和数据将被释放，且不可恢复。',
  'database.postgres.deleteSuccess': '删除成功',
  'database.postgres.deleteFail': '删除失败',
  'database.postgres.fetchListFail': '获取实例列表失败',
  'database.postgres.filterByStatus': '按状态筛选',
  'database.postgres.statusRunning': '运行中',
  'database.postgres.statusCreating': '创建中',
  'database.postgres.statusDeleting': '删除中',
  'database.postgres.statusDeleted': '已删除',
  'database.postgres.statusUpgrading': '升级中',
  'database.postgres.statusSuspended': '已暂停',
  'database.postgres.showDeleted': '显示已删除',
  'database.postgres.hideDeleted': '隐藏已删除',
  'database.postgres.deleted': '已删除',
  // 创建实例弹窗
  'database.postgres.createModal.title': '创建 PostgreSQL 数据库实例',
  'database.postgres.createModal.ownerOnly':
    '仅工作空间所有者可以创建 PostgreSQL 实例',
  'database.postgres.createModal.name': '别名',
  'database.postgres.createModal.namePlaceholder':
    '请输入别名（如：开发数据库）',
  'database.postgres.createModal.nameRequired': '请输入别名',
  'database.postgres.createModal.instanceName': '实例名称',
  'database.postgres.createModal.instanceNamePlaceholder': '留空则后台自动生成',
  'database.postgres.createModal.instanceNameInvalid':
    '实例名称长度需在 2 到 255 个字符之间，只能包含字母、数字和下划线，且必须以字母开头',
  'database.postgres.createModal.instanceNameAutoHint': '留空将自动生成',
  'database.postgres.createModal.region': '地域',
  'database.postgres.createModal.regionRequired': '请选择地域',
  'database.postgres.createModal.deploymentMode': '部署模式',
  'database.postgres.createModal.deploymentModeRequired': '请选择部署模式',
  'database.postgres.createModal.singleNode': 'Single Node',
  'database.postgres.createModal.singleNodeDesc':
    'Suitable for individual developers and small-to-medium teams. Designed for development and testing workloads.',
  'database.postgres.createModal.highAvailability': 'High Availability',
  'database.postgres.createModal.highAvailabilityDesc':
    'Designed for production workloads requiring high reliability and availability. Built-in redundancy and failover. Supports storage scaling.',
  'database.postgres.createModal.plan': '规格（Plan）',
  'database.postgres.createModal.planRequired': '请选择规格',
  'database.postgres.createModal.storage': '存储空间',
  'database.postgres.createModal.storageUnit': 'GB',
  'database.postgres.createModal.storageRange': '({min} - {max} GB)',
  'database.postgres.createModal.storageNoExpand': '存储一旦选定不可扩容',
  'database.postgres.createModal.version': 'Postgres 版本',
  'database.postgres.createModal.creditsPerHour': '积分/小时',
  'database.postgres.createModal.computeCredits': '计算资源',
  'database.postgres.createModal.storageCredits': '存储资源',
  'database.postgres.createModal.totalCredits':
    '总计每小时消耗: {credits} 积分',
  'database.postgres.createModal.quotaExceeded':
    '已超出免费计划资源额度，请升级您的计划',
  'database.postgres.createModal.pointsInsufficient':
    '您的积分不足，请充值或升级您的计划',
  'database.postgres.createModal.createSuccess': '创建请求已发送',
  'database.postgres.createModal.createFail': '创建失败',
  'database.postgres.createModal.fetchAvailabilityModesFail':
    '获取可用性模式失败',
  'database.postgres.createModal.fetchRegionsFail': '获取可用地域失败',
  'database.postgres.createModal.fetchStorageRangeFail': '获取存储范围失败',
  'database.postgres.createModal.fetchFlavorsFail': '获取可用规格失败',
  'database.postgres.createModal.createNow': '立即创建',
  // 实例详情
  'database.postgres.fetchInstanceFail': '获取实例详情失败',
  'database.postgres.overview': '概览',
  'database.postgres.databases': '数据库',
  'database.postgres.metrics': '监控',
  // 概览 Tab
  'database.postgres.overviewInstanceId': '实例 ID',
  'database.postgres.overviewInstanceName': '实例名称',
  'database.postgres.overviewStatus': '状态',
  'database.postgres.overviewRegion': '地域',
  'database.postgres.overviewMode': '可用性模式',
  'database.postgres.overviewPlan': '规格',
  'database.postgres.overviewStorage': '存储',
  'database.postgres.overviewCreatedAt': '创建时间',
  'database.postgres.overviewEngineVersion': '版本',
  'database.postgres.monitoring': '监控概览',
  'database.postgres.monitoringTimeRange': '时间范围',
  'database.postgres.monitoring1h': '最近 1 小时',
  'database.postgres.monitoring6h': '最近 6 小时',
  'database.postgres.monitoring3d': '最近 3 天',
  'database.postgres.monitoring7d': '最近 7 天',
  'database.postgres.monitoringCpu': 'CPU 利用率 (%)',
  'database.postgres.monitoringMemory': '内存利用率 (%)',
  'database.postgres.monitoringStorage': '存储使用量 (GB)',
  // 监控 Tab
  'database.postgres.metricsTimeRange': '时间范围',
  'database.postgres.metricsPrecision': '精度',
  'database.postgres.metricsPrecision1m': '1分钟',
  'database.postgres.metricsPrecision5m': '5分钟',
  'database.postgres.metricsPrecision15m': '15分钟',
  'database.postgres.metricsPrecision1h': '1小时',
  'database.postgres.metricsCpu': 'CPU 利用率',
  'database.postgres.metricsMemory': '内存利用率',
  'database.postgres.metricsStorage': '持久化存储使用量',
  'database.postgres.metricsComingSoon': '监控功能即将推出',
  // 数据库管理
  'database.postgres.createDatabase': '创建数据库',
  'database.postgres.databaseName': '数据库名称',
  'database.postgres.databaseNamePlaceholder':
    '数据库名称必须以字母开头，只能包含小写字母、数字和下划线，最长 64 个字符',
  'database.postgres.databaseNameRequired': '请输入数据库名称',
  'database.postgres.databaseNameInvalid':
    '数据库名称必须以字母开头，只能包含小写字母、数字和下划线，最长 64 个字符',
  'database.postgres.description': '描述',
  'database.postgres.descriptionPlaceholder': '请输入描述（可选）',
  'database.postgres.connectionConfigName': '配置名称',
  'database.postgres.connectionConfigNamePlaceholder': '留空将自动生成',
  'database.postgres.connectionConfigNameTip':
    '用于标识该数据库的连接配置，将出现在工作空间配置中心',
  'database.postgres.createDatabaseSuccess': '数据库创建成功',
  'database.postgres.createDatabaseSuccessDesc':
    '数据库创建成功，并生成工作空间 PostgreSQL 内置配置，可被工作流数据库节点引用',
  'database.postgres.viewConfig': '查看配置',
  'database.postgres.manageDatabase': '去管理数据库',
  'database.postgres.createDatabaseFail': '创建数据库失败',
  'database.postgres.fetchDatabasesFail': '获取数据库列表失败',
  'database.postgres.dbName': '数据库名称',
  'database.postgres.dbConfigName': '配置名称',
  'database.postgres.dbDescription': '描述',
  'database.postgres.dbCreatedAt': '创建时间',
  'database.postgres.dbOperation': '操作',
  'database.postgres.dbManage': '管理',
  'database.postgres.dbDelete': '删除',
  'database.postgres.dbDeleteConfirm': '确认删除数据库',
  'database.postgres.dbDeleteConfirmContent':
    '确定要删除数据库 {name} 吗？删除后不可恢复。',
  'database.postgres.dbDeleteSuccess': '删除数据库成功',
  'database.postgres.dbDeleteFail': '删除数据库失败',
  // 表管理
  'database.postgres.createTable': '创建数据表',
  'database.postgres.editTable': '编辑表',
  'database.postgres.copyTable': '复制表',
  'database.postgres.copyTableSchema': '复制表模式',
  'database.postgres.copyTableSchemaSuccess': 'Schema 已复制到剪贴板',
  'database.postgres.copyTableSchemaFail': '复制失败',
  'database.postgres.exportTableData': '导出表数据',
  'database.postgres.exportTableDataSuccess': '导出成功',
  'database.postgres.exportTableDataFail': '导出失败',
  'database.postgres.deleteTable': '删除表',
  'database.postgres.deleteTableConfirm':
    '确定要删除数据表 {name} 吗？删除后不可恢复。',
  'database.postgres.deleteTableSuccess': '删除表成功',
  'database.postgres.deleteTableFail': '删除表失败',
  'database.postgres.structure': '结构',
  'database.postgres.content': '内容',
  'database.postgres.query': '查询',
  'database.postgres.targetTableName': '目标表名',
  'database.postgres.targetTableNamePlaceholder': '请输入目标表名',
  'database.postgres.targetTableNameRequired': '请输入目标表名',
  'database.postgres.copyData': '复制数据',
  'database.postgres.copyDataTip': '勾选后将同时复制表数据，否则仅复制表结构',
  'database.postgres.copyTableSuccess': '复制表成功',
  'database.postgres.copyTableFail': '复制表失败',
  'database.postgres.editTableTip': '请使用 DDL SQL 语句编辑表结构',
  'database.postgres.ddlSqlPlaceholder': '请输入 DDL SQL 语句',
  'database.postgres.ddlSqlRequired': '请输入 DDL SQL 语句',
  'database.postgres.fetchTableSchemaFail': '获取表结构失败',
  'database.postgres.editTableSuccess': '编辑表成功',
  'database.postgres.editTableFail': '编辑表失败',
  // 表结构展示
  'database.postgres.columnName': '字段名称',
  'database.postgres.dataType': '数据类型',
  'database.postgres.nullable': '可为空',
  'database.postgres.defaultValue': '默认值',
  'database.postgres.primaryKey': '主键',
  'database.postgres.maxLength': '最大长度',
  // 表数据管理
  'database.postgres.selectField': '选择字段',
  'database.postgres.operator': '运算符',
  'database.postgres.inputValue': '输入值',
  'database.postgres.search': '查询',
  'database.postgres.reset': '重置',
  'database.postgres.addRow': '新增行',
  'database.postgres.showFields': '展示字段',
  'database.postgres.deleteRowConfirm': '删除确认',
  'database.postgres.deleteRowConfirmContent': '确定要删除该行吗？',
  'database.postgres.defaultValueTip': '该字段默认值：{value}',
  'database.postgres.operatorEqual': '等于',
  'database.postgres.operatorNotEqual': '不等于',
  'database.postgres.operatorGreater': '大于',
  'database.postgres.operatorGreaterEqual': '大于等于',
  'database.postgres.operatorLess': '小于',
  'database.postgres.operatorLessEqual': '小于等于',
  'database.postgres.operatorLike': '包含',
  'database.postgres.operatorStarts': '开头是',
  'database.postgres.operatorEnds': '结尾是',
  'database.postgres.operatorIsNull': '为空',
  'database.postgres.operatorIsNotNull': '不为空',
  // SQL 执行
  'database.postgres.sqlPlaceholder': '请输入 SQL 语句',
  'database.postgres.clearSQL': '清空',
  'database.postgres.executeSQL': '执行',
  'database.postgres.sqlEmptyState': '请在上方输入 SQL 语句并点击执行',
  'database.postgres.sqlInputRequired': '请输入 SQL 语句',
  'database.postgres.sqlExecuteSuccess': '执行成功，影响 {rows} 行',
  'database.postgres.sqlExecuteFail': '执行失败：{error}',
  'database.postgres.sqlHistory': '执行历史',
  'database.postgres.sqlHistoryEmpty': '暂无执行历史',
  'database.postgres.sqlHistoryClickToRestore': '点击恢复到编辑器',
  'database.postgres.sqlHistoryFetchFail': '获取执行历史失败',
  'database.postgres.sqlStatusSuccess': '成功',
  'database.postgres.sqlStatusFailed': '失败',
  // 创建表弹窗
  'database.postgres.createTableModal.title': '新建数据表',
  'database.postgres.createTableModal.ddlTip': '请使用 DDL SQL 语句创建数据表',
  'database.postgres.createTableModal.ddlPlaceholder':
    'CREATE TABLE my_table (\n  id SERIAL PRIMARY KEY,\n  name VARCHAR(255) NOT NULL\n);',
  'database.postgres.createTableModal.ddlRequired': '请输入 DDL SQL 语句',
  'database.postgres.createTableModal.createSuccess': '创建表成功',
  'database.postgres.createTableModal.createFail': '创建表失败',
  // usePostgres hook 消息
  'database.postgres.addRowSuccess': '添加数据成功！',
  'database.postgres.addRowFail': '添加数据失败：{error}',
  'database.postgres.deleteRowSuccess': '删除数据成功！',
  'database.postgres.deleteRowFail': '删除数据失败：{error}',
  'database.postgres.getTableColumnsFail':
    '获取表 {table} 字段信息失败：{error}',
  'database.postgres.getTableDataFail': '获取表 {table} 数据失败：{error}',
  'database.postgres.executeSQLSuccess': 'SQL 执行成功！',
  'database.postgres.executeSQLFail': 'SQL 执行失败：{error}',
  'database.postgres.addRowModal.title': '新增数据行',
  'database.postgres.fieldRequired': '{name} 不能为空',
  // SQLite 消息
  'database.sqlite.getTableListFailed': '获取表列表失败！',
  'database.sqlite.addTableSuccess': '添加表 {name} 成功！',
  'database.sqlite.addTableFailed': '添加表 {name} 失败',
  'database.sqlite.deleteTableSuccess': '删除表 {name} 成功！',
  'database.sqlite.deleteTableFailed': '删除表 {name} 失败！',
  'database.sqlite.getColumnsFailed': '获取表 {name} 字段信息失败！',
  'database.sqlite.getDataFailed': '获取表 {name} 数据信息失败！',
  'database.sqlite.addRowSuccess': '添加数据成功！',
  'database.sqlite.addRowFailed': '添加数据失败！',
  'database.sqlite.updateRowSuccess': '更新数据成功！',
  'database.sqlite.updateRowFailed': '更新数据失败！',
  'database.sqlite.deleteRowSuccess': '删除数据成功！',
  'database.sqlite.deleteRowFailed': '删除数据失败！',
  'database.sqlite.clearTableSuccess': '清空表 {name} 数据成功！',
  'database.sqlite.clearTableFailed': '清空表 {name} 数据失败！',
  'database.sqlite.sqlExecuteSuccess': 'SQL执行成功！',
  'database.sqlite.sqlExecuteFailed': 'SQL执行失败：{error}',
  'database.sqlite.alterTableSuccess': '修改表 {name} 结构成功！',
  'database.sqlite.alterTableFailed': '修改表 {name} 结构失败：{error}',
  'database.sqlite.modifyColumnNotSupported':
    'SQLite 不支持直接修改列结构。如需修改，请使用以下方式之一：\n1. 使用 SQL 语句重建表\n2. 使用 RENAME COLUMN 重命名列（SQLite 3.25.0+）\n3. 使用 DROP COLUMN + ADD COLUMN（SQLite 3.35.0+）',
  'database.sqlite.enterSqlStatement': '请输入SQL语句',
  'database.sqlite.executionFailed': '执行失败：{error}',
  'database.sqlite.columnNameRequired': '列名不能为空！',
  'database.sqlite.columnNameDuplicate': '列名不能重复！',
  'database.sqlite.renameColumnSuccess': '重命名列成功！',
  'database.sqlite.renameColumnFailed': '重命名列失败：{error}',
  'database.sqlite.createTable': '创建数据表',
  'database.sqlite.confirmDeleteTable': '确定要删除该数据表吗？',
  'database.sqlite.tabStructure': '结构',
  'database.sqlite.tabContent': '内容',
  'database.sqlite.tabQuery': '查询',
  'database.sqlite.selectField': '选择字段',
  'database.sqlite.operator': '运算符',
  'database.sqlite.inputValue': '输入值',
  'database.sqlite.query': '查询',
  'database.sqlite.reset': '重置',
  'database.sqlite.addRow': '新增行',
  'database.sqlite.clear': '清空',
  'database.sqlite.showFields': '展示字段',
  'database.sqlite.selectFieldsToShow': '选择要显示的字段',
  'database.sqlite.primaryKey': '主键',
  'database.sqlite.fieldDefaultValue': '该字段默认值：{value}',
  'database.sqlite.confirmDeleteField': '确定删除该字段吗?',
  'database.sqlite.clearTableData': '清空表数据',
  'database.sqlite.confirmClearData': '确认清空数据？',
  'database.sqlite.clearDataWarning': '数据清空后不可恢复，请谨慎操作。',
  'database.sqlite.opEquals': '等于',
  'database.sqlite.opNotEquals': '不等于',
  'database.sqlite.opGreaterThan': '大于',
  'database.sqlite.opGreaterOrEqual': '大于等于',
  'database.sqlite.opLessThan': '小于',
  'database.sqlite.opLessOrEqual': '小于等于',
  'database.sqlite.opContains': '包含',
  'database.sqlite.opStartsWith': '开头是',
  'database.sqlite.opEndsWith': '结尾是',
  'database.sqlite.opIsNull': '为空',
  'database.sqlite.opIsNotNull': '不为空',
  'database.sqlite.addField': '添加字段',
  'database.sqlite.fieldName': '字段名称',
  'database.sqlite.enterFieldName': '请输入字段名称',
  'database.sqlite.enterNewColumnName': '请输入新列名',
  'database.sqlite.description': '描述',
  'database.sqlite.enterFieldDescription': '请输入字段描述',
  'database.sqlite.dataType': '数据类型',
  'database.sqlite.selectDataType': '请选择数据类型',
  'database.sqlite.size': '大小',
  'database.sqlite.defaultValue': '默认值',
  'database.sqlite.isRequired': '是否必要',
  'database.sqlite.isUnique': '是否唯一',
  'database.sqlite.autoIncrement': '自增',
  'database.sqlite.isNotNull': '非空字段',
  'database.sqlite.delete': '删除',
  'database.sqlite.builtInField': '内置字段',
  'database.sqlite.createTableTitle': '新建数据表',
  'database.sqlite.tableName': '数据表名称',
  'database.sqlite.enterTableName': '请输入数据表名称',
  'database.sqlite.tableFields': '数据表字段',
  'database.sqlite.pleaseAddFields': '请添加字段',
  'database.sqlite.fieldNameRequired': '字段名不能为空！',
  'database.sqlite.fieldNameDuplicate': '字段名不能重复！',
  'database.sqlite.primaryKeyRequired': '请指定主键！',
  'database.sqlite.addFieldTitle': '新增字段',
  'database.sqlite.enterDefaultValue': '请输入默认值（可选）',
  'database.sqlite.addRowTitle': '新增数据行',
  'database.sqlite.createdAt': '创建时间',
  'database.sqlite.enterSql': '请输入SQL语句',
  'database.sqlite.execute': '查询',
  'database.sqlite.confirmDeleteColumn': '确定删除该字段吗？',
  // 通用
  'common.back': '返回',
  'common.cancel': '取消',
  'common.confirm': '确认',
};
